/**
 * mobile-drawer.js — نغمة ستور
 * فتح/إغلاق القائمة الجانبية للجوال: بالزر، بمفتاح Escape، وبالضغط خارج
 * اللوحة. يمنع تمرير الصفحة خلفها ويحصر التركيز داخلها لدعم الوصول.
 */
(function () {
  "use strict";

  var removeFocusTrap = null;
  var lastTrigger = null;

  function openDrawer(drawer, trigger) {
    // إلغاء أي مؤقت إغلاق معلَّق من إغلاق سريع سابق، حتى لا يضيف hidden
    // على الدرج بعد إعادة فتحه للتو (فتح/إغلاق/فتح سريع خلال أقل من 220ms).
    if (drawer.closeTimer) {
      window.clearTimeout(drawer.closeTimer);
      drawer.closeTimer = null;
    }

    drawer.removeAttribute("hidden");
    // إعادة تدفق (reflow) قبل إضافة صنف الفتح حتى يعمل الانتقال (transition)
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    lastTrigger = trigger || lastTrigger;
    document.querySelectorAll("[data-mobile-drawer-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "true");
    });
    Naghmah.lockScroll();
    removeFocusTrap = Naghmah.trapFocus(drawer);
  }

  function closeDrawer(drawer) {
    if (!drawer || drawer.hasAttribute("hidden")) return;
    drawer.classList.remove("is-open");
    document.querySelectorAll("[data-mobile-drawer-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
    });
    Naghmah.unlockScroll();
    if (removeFocusTrap) {
      removeFocusTrap();
      removeFocusTrap = null;
    }

    if (drawer.closeTimer) {
      window.clearTimeout(drawer.closeTimer);
    }
    drawer.closeTimer = window.setTimeout(function () {
      drawer.setAttribute("hidden", "");
      drawer.closeTimer = null;
    }, 220); // يطابق --transition-base في design-tokens.css
  }

  /**
   * تصحيح: إعادة التركيز بعد الإغلاق (بزر الإغلاق أو Escape) كانت تذهب
   * دائمًا لأول زر [data-mobile-drawer-toggle] موجود في الصفحة، بغض النظر
   * عن الزر الذي فتح الدرج فعليًا. الآن نتتبع lastTrigger (نفس نمط
   * mega-menu.js) ونعيد التركيز إليه تحديدًا.
   */
  function closeAndRestoreFocus(drawer) {
    closeDrawer(drawer);
    var returnTo = lastTrigger || document.querySelector("[data-mobile-drawer-toggle]");
    if (returnTo) returnTo.focus();
  }

  function initSubmenus(drawer) {
    var toggles = drawer.querySelectorAll("[data-mobile-submenu-toggle]");
    toggles.forEach(function (toggle) {
      if (toggle.dataset.submenuBound === "true") return;
      toggle.dataset.submenuBound = "true";

      toggle.addEventListener("click", function () {
        var controlsId = toggle.getAttribute("aria-controls");
        var submenu = controlsId ? document.getElementById(controlsId) : toggle.parentElement.nextElementSibling;
        if (!submenu) return;
        var isOpen = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", (!isOpen).toString());
        if (isOpen) {
          submenu.setAttribute("hidden", "");
        } else {
          submenu.removeAttribute("hidden");
        }
      });
    });
  }

  function initMobileDrawer() {
    var drawer = document.getElementById("MobileDrawer");
    if (!drawer || drawer.dataset.drawerInitialized === "true") return;
    drawer.dataset.drawerInitialized = "true";

    initSubmenus(drawer);

    document.querySelectorAll("[data-mobile-drawer-toggle]").forEach(function (trigger) {
      if (trigger.dataset.drawerTriggerBound === "true") return;
      trigger.dataset.drawerTriggerBound = "true";
      trigger.addEventListener("click", function () {
        openDrawer(drawer, trigger);
      });
    });

    drawer.querySelectorAll("[data-mobile-drawer-close]").forEach(function (closeBtn) {
      if (closeBtn.dataset.drawerCloseBound === "true") return;
      closeBtn.dataset.drawerCloseBound = "true";
      closeBtn.addEventListener("click", function () {
        closeAndRestoreFocus(drawer);
      });
    });

    drawer.addEventListener("keydown", function (evt) {
      if (evt.key === "Escape") {
        closeAndRestoreFocus(drawer);
      }
    });
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    Naghmah.registerSection("header", initMobileDrawer);
  }

  Naghmah.onReady(initMobileDrawer);
})();
